<template>
    <form>
        <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-2">
            <Message severity="info" class="p-col-12">
                Seleccione el motivo por el cual está postulando. Lea atentamente y verifique todas las personas que componen su hogar. Si la información es correcta presione
                siguiente, en caso que <b>el núcleo familiar no coincida</b> presione cancelar. 
            </Message>

            <div class="p-field p-col-12 p-md-6">
                <label for="motivo">Motivo por el cual realiza el formulario</label>
                <Dropdown id="motivo" v-model="selectedReason" :options="motivos" optionLabel="name" optionValue="id" placeholder="Seleccionar" 
                autofocus :class="{'p-invalid': submittedReason && !selectedReason}"/>
                <small class="p-invalid" v-if="submittedReason && !selectedReason">Se requiere seleccionar un motivo de postulación.</small>
            </div>

            <div class="p-field p-col-12 p-md-12">
                <DataTable :value="nucleo" :loading="loadingtable" responsiveLayout="stack" showGridlines class="mt-3">
                <template #header>
                    <div>
                        Integración del núcleo familiar
                    </div>
                </template>
                <template #empty>
                    No hay información relacionada a su núcleo familiar.
                </template>
                <template #loading>
                    Cargando núcleo familiar. Espere por favor.
                </template>
                <Column field="ci" header="CI" style="width:20%"></Column>
                <Column field="fecha" header="Fecha nacimiento" style="width:20%"></Column>
                <Column field="nombre" header="Nombre completo" style="width:60%"></Column>
			</DataTable>
            </div>
        </div>
        <Toolbar>
            <template v-slot:left>
                <Button label="Cancelar" @click="open" class="p-button-warning" icon="pi pi-times" iconPos="left"/> 
                <Dialog :closable="false" :closeOnEscape="false" header="La información no coincide" :visible="display" :breakpoints="{'960px': '75vw'}" :style="{width: '30vw'}" :modal="true">
					<p>
                    Debe concurrir a la <a href="https://www.gub.uy/ministerio-desarrollo-social/territorio" target="_blank">Oficina Territorial</a> mas cercana para recibir asistencia.
					</p>
					<template #footer>
						<Button label="Salir" @click="close" icon="pi pi-check" class="p-button-secondary"/>
					</template>
				</Dialog>
            </template>

            <template v-slot:right>
                <Button label="Siguiente" @click="nextPage()" icon="pi pi-angle-right" iconPos="left"/> 
            </template>
        </Toolbar>
    </form>

    <Dialog header="Atención" :visible="displayActive" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '50vw'}" :modal="true" :closable="false" :closeOnEscape="false">
        <p>El motivo seleccionado no es correcto, usted no cuenta con una intervención activa para el beneficio.</p>
        <template #footer>
            <Button label="Entendido" icon="pi pi-check" @click="closeDialogActive" autofocus />
        </template>
    </Dialog>

    <Dialog header="Atención" :visible="displayEstado" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '50vw'}" :modal="true" :closable="false" :closeOnEscape="false">
        <p>La persona ya posee un intervención en estado abierto (iniciaado, aceptado, beneficiario, suspendido).</p>
        <template #footer>
            <Button label="Entendido" icon="pi pi-check" @click="closeDialogEstado" autofocus />
        </template>
    </Dialog>
</template>

<script>
import SmartService from '../service/SmartService';
export default {
    props:{ 
        form: Object,
    },
	data() {
		return {
            display: false,
            wait: false,
            nucleo: null,
            titular: null,
            selectedReason: null,
            loadingtable: true,
            postulacion:{},
			submittedCel: false,
			isMobile: false,
            auxSplit: null,
            submittedReason: false,
            motivos:[
                {name: "Nueva postulación", id:1},
                {name:"Modificación del núcleo", id:2},
                {name:"Repostulación", id:3},
            ],
            tieneactiva: false,
            displayActive: false,
            displayEstado: false,
		}
	},	
	smartService: null,
	created() {
		this.smartService = new SmartService();
        this.$workbox.addEventListener("message", () => {
            //Ver event que está deprecated
            //Controlo si la red a la que estoy conectado tiene acceso a Internet
            if (event.data === "events-returned-from-cache") {
                this.$router.replace({ name: "offline" });
            }
        });

	},
	mounted() {
        this.cargarDatos();
	},
	methods: {
        open() {
				this.display = true;
			},
        close() {
            this.display = false;
            this.$router.replace({ name: "Datos personales" });
        },
        openDialogActive(){
            this.displayActive = true;
        },

        closeDialogActive(){
            this.displayActive = false;
        },
        openDialogEstado(){
            this.displayEstado = true;
        },

        closeDialogEstado(){
            this.displayEstado = false;
        },
        async cargarDatos() {
            this.wait= true;
            await this.smartService.getHogar().then(data => {
                this.outcome = [];
                this.nucleo = [];
                this.outcome = data;
                this.loadingtable = false;
                for (let p of this.outcome){
                    this.auxSplit = p.nombreEnCedula.split(" ");
                    let nombre = null;
                    for (let n of this.auxSplit){
                        if (!nombre){
                            nombre = this.maskCharacter(n);    
                        }
                        else {
                            nombre = nombre + " " + this.maskCharacter(n);                                
                        }
                    }    
                    if (p.docPrimario.numero === localStorage.cedula)
                        this.titular = p.id;
                    let cedula = this.maskCharacter(p.docPrimario.numero);
                    let aux = {};
                    if (p.edad >= 14)
                        aux = {id: p.id, ci:cedula, nombre: nombre, fecha: p.fechaNac, edad: p.edad, sexo: p.codSexo.codigo, ingresos: null};  
                    else
                        aux = {id: p.id, ci:cedula, nombre: nombre, fecha: p.fechaNac, edad: p.edad, sexo: p.codSexo.codigo, ingresos: 0};  
                    this.nucleo.push(aux);  
                }
                
            })
            //Me fijo si tiene una intervención activa
            this.checkIntervencionActiva();
            this.wait= false;
        },

        async checkIntervencionActiva() {
			this.wait= true;		
			//console.log("Validando intervención activa");
			await this.smartService.getIntervenciones().then(data => {
					this.tieneactiva = false
					for (let b of data) {
						//console.log("Recorriendo intervenciones");
                        //CHEQUEO PARA COMEDORES
						if (b.intervencion.beneficio.programa.id == 126){
                            //console.log("Encontre una");
							this.tieneactiva = true;
						}
					}
            });
			//console.log("Saliendo de checkIntervencionActiva");
			this.wait= false;
		},

        nextPage(){
            this.submittedReason = true;
            //console.log("Tiene activa?:" + this.tieneactiva);
            if (this.selectedReason == 1 && this.tieneactiva){
                this.openDialogEstado();
            }
            else if (this.selectedReason == 1 || ((this.selectedReason == 2 || this.selectedReason == 3) && this.tieneactiva)){
                    if (this.loadingtable == false){
                        this.wait = true;
                        this.postulacion.nucleo = this.nucleo;
                        this.postulacion.titular = this.titular;
                        this.postulacion.motivoId = this.selectedReason;
                        this.$emit('next-page', {form: {postulacion: this.postulacion}, pageIndex: 0}); 
                        this.wait = false;
                    }
                    else{
                        this.$toast.add({severity:'warn', summary:'Atención', detail:'Cargando núcleo familiar. Espere por favor.', life: 3000});
                    }
                }
                else{
                    if ((this.selectedReason == 2 || this.selectedReason == 3) && !this.tieneactiva)
                        this.openDialogActive();
                }
        },

        maskCharacter(str) {
            let m = null;
            if (str.length % 2 != 0) {
                m = Math.floor(str.length / 2);
            }
            else{
                m = str.length / 2;
            }
            let aux1 = ('' + str).slice(0, -m);
            let aux2 = ('' + str).slice(-m);
            let aux3 = aux2.replace(/./g,'*');
            let nombre = aux1 + aux3;
            return nombre;
        }
	},
}
</script>
